const kr = {
    9000001: "2023 크리스마스 컵",
    9000002: "슈퍼엑스 선물 거래 대회",
    9000003: "30,000USDT 대회 상금을 획득하세요",
    9000004: "참가자 수",
    9000005: "해제된 보상 풀 (USDT)",
    9000006: "선물 거래량 순위 예선 대회 ",
    9000007: "선물 수익률 순위 대회 ",
    9000008: "수익성 랭킹 경쟁 ",
    9000009: `선물 거래량 순위 경쟁을 통해 최대 <span style="color: #ffc72b;">20,000</span> USDT의 보너스 풀을 잠금 해제하세요`,
    9000010: "참가자 수에 따라 최대 20,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ",
    9000011: "상금 풀 금액",
    9000012: "活動 기간 중 매일 오전 10시 (UTC)에 업데이트됩니다",
    9000013: "보상 별",
    9000014: "통계적 선물 거래 금액",
    9000015: "보상 규칙",
    9000016: "참가자 수에 따라 최대 20,000USDT의 상금이 주어지며, 참가자 수가 많을수록 상금의 규모도 커집니다. ",
    9000017: "상금 풀 금액 (USDT)",
    9000018: "활동 수익률 순위",
    9000019: "가입",
    9000020: "활동 순익 순위",
    9000021: "마치다",
    9000022: `선물 수익률 순위 경쟁, <span style="color: #ffc72b;">{moneyPond}</span> USDT 보너스 분할 지급 `,
    9000023: `선물 수익률 랭킹 대회, <span style="color: #ffc72b;">{moneyPond}</span> USDT 보너스 지급`,
    9000024: "누적 선물 수익률 ",
    9000025: "총 선물 수익 ",
    9000026: "시작하지 않았다",
    9000027: "선물 수익률 순위 상위 50명에게 보상이 지급되며, 보너스 보상은 트레이딩 순위 보상 규정을 참조하세요.",
    9000028: "선물 수익률 기준 상위 50명의 참가자에게 보상이 지급되며, 보상을 받으려면 트레이딩 랭킹 보상 규정을 참조하세요. ",
    9000029: "활동 거래액 순위",
    9000030: "등록 성공",
    9000031: "App 다운로드",
    9000032: "홈페이지로 돌아가기",

    //合约交易积分
    9100001: '적분을 모으다',
    9100002: '공중 투하를 받다',
    9100003: '태환 보상',
    9100004: '포인트 잔액',
    9100005: '명세',
    9100006: '출석 포인트',
    9100007: '거래 포인트',
    9100008: '초대 포인트',
    9100009: '보상 포인트',
    9100010: '행운 추첨',
    9100011: '포인트 획득',
    9100012: '포인트 규칙',
    9100013: '포인트 명세',
    9100014: '당신은 신청을 해야만 이 활동에 참여할 수 있으며, 클릭하면 참여할 수 있습니다',
    9100015: '{day}일 연속 거래 및 {num}포인트 획득',
    9100016: '오늘 이미 {num} 포인트 획득',
    9100017: '포인트 보너스 풀',
    9100018: '매번 추첨 시 {point} 포인트 소모, 매일 최대 {num} 회 추첨',
    9100019: '오늘 추첨 횟수',
    9100020: '사용자',
    9100021: '포인트',
    9100022: '포인트 잔액 부족',
    9100023: '포인트 잔액 부족, 포인트 획득 후 추첨에 참여 하세요',
    9100024: '추첨 횟수가 이미 상한에 도달하였습니다.',
    9100025: '오늘 추첨 횟수가 이미 상한에 도달했으니, 내일 다시 시도해 보십시오.',
    9100026: '포인트를 얻는 방법',
    9100027: '계약거래 포인트 적립 활동에 참여하여 포인트를 적립해보세요.',
    9100028: '참여 신청 성공',
    9100029: '당신은 이미 계약 거래 포인트 획득 이벤트에 참가 신청을 하였습니다. 거래에 가서 더 많은 포인트를 획득하세요 (더 이상 캐시백 보상을 받지 않습니다)',
    9100030: '신청을 취소한 후 더 이상 포인트를 받지 못합니다. 신청을 취소하시겠습니까?',
    9100031: '거래 포인트 이벤트 센터',
    9100032: '포인트 획득',
    9100033: '당신은 신청을 해야만 이 활동에 참여할 수 있으며, 클릭하면 참여할 수 있습니다',
    9100034: '연속으로 계약 포인트에 참여하면 포인트를 획득할 수 있습니다',
    9100035: '사용자가 계약 시장에서 발생하는 모든 거래 행위로 포인트를 획득할 수 있다',
    9100036: '랭킹 포인트',
    9100037: '일일 거래 랭킹 전 5 위 및 추가 보상 포인트',
    9100038: '초대받은 사람은 포인트를 생성, 초대인은 보상 포인트를 획득할 수 있습니다',
    9100039: '{guy} 이미 당첨<span style="color:#D9A31A"> {num} 포인트</span>',
    9100040: '지금 추첨',
    9100041: '획득을 축하합니다',
    9100042: '모든 유형',
    9100043: '이 페이지에 머물다',
    9100044: '등록에 참여',
    9100045: '계속 거래하세요',
    9100046: '현재 진행중인 활동은 없습니다. 많은 관심 부탁드립니다.',
    9100047: 'SCS 토큰 교환',
    9100048: '',
    9100049: '',

    9100050: '날짜',
    9100051: '시작 날짜',
    9100052: '종료 시간',
    9100053: 'to',
    9100054: '유형',

    9100055: '획득 포인트 = 거래량 * 1% (플랫폼의 총 거래량이 증가함에 따라 난이도는 추가 조정됩니다.)',
    9100056: '예: 사용자는 마진이 100USDT*100X=10000U인 포지션을 사용합니다.',
    9100057: '그런 다음 100포인트를 얻으려면 100USDT의 보증금만 있으면 됩니다. ',
    9100058: '거래 포인트는 플랫폼 토큰 SCS를 얻을 수 있는 유일한 방법입니다',
    9100059: '추가 보너스 포인트 = 당일 총 포인트 * 순위 보상 비율',
    9100060: '순위',
    9100061: '일등',
    9100062: '2등',
    9100063: '삼등',
    9100064: '넷째',
    9100065: '다섯 번째',
    9100066: '초대받은 사람은 포인트를 생성, 초대인은 보상 포인트를 획득할 수 있습니다',
    9100067: '등급계수',
    9100068: '계산식: 획득한 승급 포인트 = 초대 대상자가 획득한 포인트 * 레벨 계수',
    9100069: '레벨 계수는 실제 상황에 따라 조정됩니다.',
    9100070: `예: 사용자 B가 포인트 활동에 참여하고 초대자는 사용자 A이고 사용자 A의 초대 수가 레벨 3에 도달했으며 사용자 B는 누적 포인트 = 360,000입니다.`,
    9100071: '그러면 사용자 A가 획득할 수 있는 누적 프로모션 포인트 = 360000* 30% = 108,000',
    9100072: '보상계수',
    9100073: '거래 사용자 1명',
    9100074: '거래량이 500W에 도달',
    9100075: '거래량이 2000W에 도달',

    9100076: '전송',

    //热币
    9100080: '이벤트가 종료되었습니다',
    9100081: '"참가 신청"을 클릭하여 대상을 획득',
    9100082: '규칙 보기',
    9100083: '참가 신청',
    9100084: '활동',
    9100088: '거래',
    9100089: '보증금',
    9100090: '이벤트에 등록되었습니다',

    9100091: '이벤트가 중료 되었습니다，다음 이벤트를 기다려 주세요！',
    9100092: '행사가 아직 시작되지 않았으니 기다려주시기 바랍니다.',
    9100093: '',
    9100094: '',

    //api key
    9100105: 'API 키 생성',
    9100106: 'API 문서 보기',
    9100107: '통합 거래 시스템',
    9100108: 'API 키 생성/관리',
    9100109: 'API 배포',
    9100110: '거래 및 요청',
    9100111: '선도적인 디지털 자산 거래 플랫폼',
    9100112: '다양한 거래 요구를 충족시키는 풍부한 디지털 자산 거래 및 자산 관리 서비스를 제공합니다.',
    9100113: '더 나은 서비스 제공',
    9100114: '더 우수한 거래 수수료, 더 높은 거래 금액, 더 유연한 계정 관리 기능 등을 제공합니다.',
    9100115: '수백만 사용자의 신뢰 선택',
    9100116: '안전한 거래 환경을 보장하고 전문적인 고객 지원을 제공하여 디지털 자산 세계에서 꾸준히 전진할 수 있도록 돕습니다.',
    9100117: 'SuperEx에서 API 키를 생성하는 방법은 무엇입니까?',
    9100118: 'SuperEx의 API 문서는 어디에서 볼 수 있습니까?',
    9100119: 'SuperEx에서 거래에 문제가 발생한 경우 어떻게 해야 합니까?',
    9100120: 'SuperEx의 API를 사용하는 방법은 무엇입니까?',
    9100121: 'SuperEx API에 연결하여 더 빠르고 원활한 거래를 경험하세요.',
    9100122: `로그인 상태에서 프로필 사진 위로 마우스를 올리고 'API 관리'를 클릭한 다음 'API 키 생성'을 클릭하여 SuperEx에서 귀하의 API 키를 생성합니다. 로그인하지 않은 경우 SuperEx 계정에 먼저 로그인해야 합니다. 또한 하단의 'APIs' 탭에서도 API 키를 생성할 수 있습니다.`,
    9100123: '<a style="color:#d1a53e;text-decoration:underline !important;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;" href="https://docs-api.superex.com">API 문서</a>를 클릭하여 SuperEx의 API 문서를 확인할 수 있습니다',
    9100124: '사용 중 문제나 제안이 있을 경우, 다음 방법으로 저희에게 연락할 수 있습니다: <br>공식 웹사이트의 "도움말 센터"를 통하거나 support@superex.com으로 이메일을 보내 고객 서비스에 연락하세요.',
    9100125: `SuperEx의 API를 사용하려면 다음 단계를 따라야 합니다:<br>
SuperEx 계정에 등록하고 로그인하세요.<br>
이 access_key와 secret_key를 사용하여 요청에 서명하세요. <br>
필요에 따라 SuperEx가 제공하는 다양한 API, 예를 들어 시장 데이터 API, 거래 API, 계정 API 등을 사용할 수 있습니다. 각 요청은 API 문서의 지침을 따라야 하며 적절한 HTTP 헤더와 서명이 포함되어야 합니다.`,
    9100126: 'API 키 관리',
    9100127: '새 API 키 생성',
    9100128: '비고명',
    9100129: '비고명을 입력하세요',
    9100130: '권한 설정 (다중 선택 가능)',
    9100131: '읽기',
    9100132: '거래',
    9100133: 'IP 주소 연결 (선택 사항)',
    9100134: '여러 IP 주소는 영어 쉼표로 구분하고, 최대 10개 주소를 입력할 수 있습니다.',
    9100135: '읽고 동의합니다',
    9100136: 'API 사용자 위험 고지 사항을 읽고 동의하였습니다.',
    9100137: '생성',
    9100138: 'SuperEx는 강력한 API를 제공합니다. 이 API를 통해 시장 조회, 자동 거래 등의 서비스를 이용할 수 있습니다. <a style="color:#0052D9;font-size: 14px;font-family: Lato-Regular, Lato;font-weight: 400;text-decoration:underline !important;color:#d1a53e;" href="https://docs-api.superex.com">API 문서</a>를 통해 사용 방법을 확인하세요.',
    9100139: '사용자는 최대 10개의 API 키 그룹을 생성할 수 있습니다.',
    9100140: `IP 주소가 연결되지 않은 API 키는 90일 후 자동으로 만료됩니다. 장기간 사용하실 경우 아래 '내 API 키 — 조치 — 갱신'에서 API 키의 유효기간을 90일 연장할 수 있습니다. IP 주소가 연결된 API 키는 유효 기간 제한이 없습니다.`,
    9100141: '내 API 키',
    9100142: '권한',
    9100143: 'IP 주소 바인딩',
    9100144: '갱신',
    9100145: 'API 키 생성을 위해 현물 지갑에 임의 금액을 입금하여 계정을 활성화하세요',
    9100146: '현재 API 키의 갱신을 확인하세요',
    9100147: 'Access Key 및 Secret Key를 누설하지 마세요. 이로 인해 자산 손실이 발생할 수 있습니다.',
    9100148: '보안상의 이유로 API 키에 IP 주소를 연결할 것을 권장합니다. 각 API 키는 최대 10개의 IP 주소를 연결할 수 있습니다. 단일 IP 주소를 직접 입력하고, 여러 IP 주소는 쉼표로 구분하여 입력하세요. 예: 192.168.1.1,192.168.1.2',
    9100149: '갱신에 성공하면 만료 시간이 재계산됩니다. API 키를 장기간 사용하려면 IP 주소를 바인딩하는 것이 좋습니다. 바인딩된 API 키는 만료되지 않으며 더 안전합니다.',
    9100150: '현재 API 키를 삭제하시겠습니까?',
    9100151: '다음과 같은 위험을 이해해야 합니다:',
    9100152: 'API 키는 귀하의 계정 보안과 밀접하게 연관되어 있습니다. 귀하의 API 키를 알고 있는 제3자는 귀하의 계정 자산을 통제할 수 있으므로, API 키를 잘 보관하고 제3자에게 공개하지 마시고, 제3자 웹사이트와 포럼에 업로드하지 마세요.',
    9100153: '귀하의 개인적인 이유로 API 키가 유출되어 발생하는 자산 안전 문제, 경제적 손실 문제 등을 포함한 모든 책임은 귀하가 직접 부담합니다. 저희는 이에 대해 책임을 지지 않습니다.',
    9100154: '위험 알림',
    9100155: '저는 위험을 인식하고 자진하여 수용할 의향이 있다는 것을 알려드립니다.',
    9100156: '저장했습니다',
    9100157: '권한 설정',
    9100158: '키는 한 번만 표시되며, 분실 후에는 복구할 수 없습니다. 반드시 안전하게 보관하세요.',
    9100159: 'Access Key 및 Secret Key를 누설하지 마세요. 이로 인해 자산 손실이 발생할 수 있습니다.',
    9100160: 'Secret Key를 잊어버렸다면 해당 키 쌍을 삭제하고 새로운 키 쌍을 신청하세요.',
    9100161: '우리는 강력한 API를 제공하여 거래 기능을 애플리케이션에 효과적으로 통합할 수 있도록 도와줍니다. API는 계정, 거래, 시장 데이터의 세 가지로 분류되며, 요구에 따라 적절한 권한을 구성할 수 있으며 API를 통해 자동 거래를 구현할 수 있습니다.',
    9100162: '생성 시간',
    9100163: '새 API 키 생성',
    9100164: '편집하다',
    9100165: '만료일',
    9100166: '삭제',
    9100167: '성공적으로 생성되었습니다.',
    9100168: '도움말',
    9100169: '좋아요',
    9100170: 'API 사용자 위험 경고',
    9100171: 'IP 주소 형식이 올바르지 않습니다',
    9100172: '',
    //自由区二维码分享页面
    91000951: '자유 구역 상장, 부의 자유 시작',
    91000961: '앱 열기',
    //自由区二维码分享页面
    9100095: '자유 구역 상장, 부의 자유 시작',
    9100096: '앱 열기',
    9100097: '',
    9100098: '',
}
export default kr



// WEBPACK FOOTER //
// ./src/i18n/langs/languageJame/kr.js